"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.revoke = exports.query = exports.store = void 0;
const tslib_1 = require("tslib");
const utils_1 = require("@kiltprotocol/utils");
const config_1 = require("@kiltprotocol/config");
const chain_helpers_1 = require("@kiltprotocol/chain-helpers");
const Attestation_1 = tslib_1.__importDefault(require("./Attestation"));
const log = config_1.ConfigService.LoggingFactory.getLogger('Attestation');
/**
 * @param attestation
 * @internal
 */
async function store(attestation) {
    const txParams = {
        claimHash: attestation.claimHash,
        ctypeHash: attestation.cTypeHash,
        delegationId: attestation.delegationId,
    };
    log.debug(() => `Create tx for 'attestation.add'`);
    const blockchain = await chain_helpers_1.BlockchainApiConnection.getConnectionOrConnect();
    const tx = blockchain.api.tx.attestation.add(txParams.claimHash, txParams.ctypeHash, txParams.delegationId);
    return tx;
}
exports.store = store;
function decode(encoded, claimHash // all the other decoders do not use extra data; they just return partial types
) {
    var _a;
    utils_1.DecoderUtils.assertCodecIsType(encoded, ['Option<Attestation>']);
    if (encoded.isSome) {
        const chainAttestation = encoded.unwrap();
        const attestation = {
            claimHash,
            cTypeHash: chainAttestation.ctypeHash.toString(),
            owner: chainAttestation.attester.toString(),
            delegationId: ((_a = chainAttestation.delegationId.unwrapOr(null)) === null || _a === void 0 ? void 0 : _a.toString()) || null,
            revoked: chainAttestation.revoked.valueOf(),
        };
        log.info(`Decoded attestation: ${JSON.stringify(attestation)}`);
        return Attestation_1.default.fromAttestation(attestation);
    }
    return null;
}
// return types reflect backwards compatibility with mashnet-node v 0.22
async function queryRaw(claimHash) {
    log.debug(() => `Query chain for attestations with claim hash ${claimHash}`);
    const blockchain = await chain_helpers_1.BlockchainApiConnection.getConnectionOrConnect();
    const result = await blockchain.api.query.attestation.attestations(claimHash);
    return result;
}
/**
 * @param claimHash
 * @internal
 */
async function query(claimHash) {
    const encoded = await queryRaw(claimHash);
    return decode(encoded, claimHash);
}
exports.query = query;
/**
 * @param claimHash
 * @param maxDepth
 * @internal
 */
async function revoke(claimHash, maxDepth) {
    const blockchain = await chain_helpers_1.BlockchainApiConnection.getConnectionOrConnect();
    log.debug(() => `Revoking attestations with claim hash ${claimHash}`);
    const tx = blockchain.api.tx.attestation.revoke(claimHash, maxDepth);
    return tx;
}
exports.revoke = revoke;
